import { render, staticRenderFns } from "./physicalState.vue?vue&type=template&id=9a2a9fb6&scoped=true&"
import script from "./physicalState.vue?vue&type=script&lang=js&"
export * from "./physicalState.vue?vue&type=script&lang=js&"
import style0 from "./physicalState.vue?vue&type=style&index=0&id=9a2a9fb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2a9fb6",
  null
  
)

export default component.exports